import axios from 'axios';
import {
    SET_JD_CAT_COVER_DATA,
    SHOW_HIDE_JD_CAT_COVER
} from '../actions/types';

export const getAllJdCatCoverData = (option) =>{
    return(dispatch)=>{
        axios.get(`/vendorapis/products/inventory/getProductCountAgainstJdmartid?docid=${option.docid}`)
            .then(data => {
                // options.cb && options.cb(data.data);
                dispatch({
                    type: SET_JD_CAT_COVER_DATA,
                    payload: {
                        data: data.data,
                    }
                });
            });
    }
}

export const showHideJdCatCover = (status)=>{
    return (dispatch)=>{
        dispatch({
            type: SHOW_HIDE_JD_CAT_COVER,
            payload: {
                toggle: status
            }
        })
    }
}

export const addJdCatCoverData = (data, options) => {
    let formData = new FormData();
    formData.append('supplierId', data.supplierId);
    formData.append('docId', data.docId);
    formData.append('request', data.request);
    axios.post(`/vendorapis/products/ajax/saveDispositionJdmart`,formData)
    .then(({data}) => {
        if(data){
            options.cb && options.cb(data);
        }
    });
}